import { CameraSection } from './sections/CameraSection'
import { ScreenShareSection } from './sections/ScreenShareSection'

export function VideoSettings(props: { inSession: boolean }) {
    return (
        <div className="flex flex-col gap-[10px]">
            <CameraSection />
            <ScreenShareSection inSession={props.inSession} />
        </div>
    )
}
